import Genre from './MusicGenre';
import Loop from './Loop';
import { getBaseURL } from '../utils/S3Utils';

const loops: Loop[] = [
  //   C I N E M A T I C
  {
    name: 'Inspiring',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/rl/aspire-cue.m4a',
    duration: 38,
    labelId: 'beatflyer',
    genre: Genre.Cinematic,
    shouldEdit: true
  },
  {
    name: 'Motivate',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/rl/motivate-cue.m4a',
    duration: 36,
    labelId: 'beatflyer',
    genre: Genre.Cinematic,
    shouldEdit: true
  },
  {
    name: 'Inspirational',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/rl/08-inspirational-cue.m4a',
    duration: 38,
    labelId: 'beatflyer',
    genre: Genre.Cinematic,
    shouldEdit: true
  },
  {
    name: 'Epic Inspiring 1',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/rl/09-epic-inspiring-ver-1.m4a',
    duration: 54,
    labelId: 'beatflyer',
    genre: Genre.Cinematic,
    shouldEdit: true
  },
  {
    name: 'Epic Inspiring 2',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/rl/09-epic-inspiring-ver-2.m4a',
    duration: 42,
    labelId: 'beatflyer',
    genre: Genre.Cinematic,
    shouldEdit: true
  },
  {
    name: 'Piano Cinematic 1',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/rl/12-piano-cinematic-ver1.m4a',
    duration: 52,
    labelId: 'beatflyer',
    genre: Genre.Cinematic,
    shouldEdit: true
  },
  {
    name: 'Piano Cinematic 2',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/rl/12-piano-cinematic-ver2.m4a',
    duration: 42,
    labelId: 'beatflyer',
    genre: Genre.Cinematic,
    shouldEdit: true
  },
  {
    name: 'Ambient Corporate',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/rl/13-ambient-corporate.m4a',
    duration: 38,
    labelId: 'beatflyer',
    genre: Genre.Cinematic,
    shouldEdit: true
  },
  //   U P B E A T
  {
    name: 'Upbeat',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/rl/upbeat-cue.m4a',
    duration: 31,
    labelId: 'beatflyer',
    genre: Genre.Upbeat,
    shouldEdit: true
  },
  {
    name: 'Aspire',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/rl/aspire-cue.m4a',
    duration: 36,
    labelId: 'beatflyer',
    genre: Genre.Upbeat,
    shouldEdit: true
  },
  {
    name: 'Be Happy',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/rl/be-happy-cue.m4a',
    duration: 35,
    labelId: 'beatflyer',
    genre: Genre.Upbeat,
    shouldEdit: true
  },
  {
    name: 'Fun',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/rl/06-fun-cue.m4a',
    duration: 32,
    labelId: 'beatflyer',
    genre: Genre.Upbeat,
    shouldEdit: true
  },
  {
    name: 'Upbeat Rock',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/rl/07-upbeat-rock-cue.m4a',
    duration: 33,
    labelId: 'beatflyer',
    genre: Genre.Upbeat,
    shouldEdit: true
  },
  {
    name: 'Upbeat Hip-Hop',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/rl/10-upbeat-hip-hop.m4a',
    duration: 44,
    labelId: 'beatflyer',
    genre: Genre.Upbeat,
    shouldEdit: true
  },
  {
    name: 'Energetic Fun',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/rl/14-energetic-fun-upbeat.m4a',
    duration: 40,
    labelId: 'beatflyer',
    genre: Genre.Upbeat,
    shouldEdit: true
  },
  //   N A T I V E   S O U L
  {
    name: 'Hummingbirds 1',
    artist: 'Matt Mason & Bobby Breezy',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/hummingbirds-1.m4a',
    duration: 11,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'Hummingbirds 2',
    artist: 'Matt Mason & Bobby Breezy',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/hummingbirds-2.m4a',
    duration: 11,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: '2 The Groove',
    artist: 'Spicy Brothers',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/2-the-groove.m4a',
    duration: 21,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'In Motion',
    artist: 'Acie',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/in-motion.m4a',
    duration: 11,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'In Need',
    artist: 'Forrest Avery',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/in-need.m4a',
    duration: 10,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'Enpanadas',
    artist: 'Tommy Largo',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/empanadas.m4a',
    duration: 10,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'Time to Ride',
    artist: 'Jeff Dougler & Balu',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/time-to-ride.m4a',
    duration: 19,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'Into My Life 1',
    artist: 'Bobby Breezy & Richie Kidd',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/into-my-life-1.m4a',
    duration: 20,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'Into My Life 2',
    artist: 'Bobby Breezy & Richie Kidd',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/into-my-life-2.m4a',
    duration: 20,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'Into My Life 3',
    artist: 'Bobby Breezy & Richie Kidd',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/into-my-life-3.m4a',
    duration: 18,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'Jazz Mode',
    artist: 'Tommy Largo',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/jazz-mode.m4a',
    duration: 21,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'You Already Know What It Is',
    artist: 'Corduroy Mavericks',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/you-already-know-what-it-is.m4a',
    duration: 8,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'Vintage Everything',
    artist: 'J Bleds Sucks',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/.m4a',
    duration: 21,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'Filter Love',
    artist: 'Tommy Largo',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/filter-love.m4a',
    duration: 20,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'A Dabbers Delight',
    artist: 'Forrest Avery & Bobby Breezy',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/a-dabber-delight.m4a',
    duration: 21,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'Pretty Baby',
    artist: 'Matt Mason',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/pretty-baby.m4a',
    duration: 19,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'Yep Jazzy',
    artist: 'Adam Osuna',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/yep-jazzy.m4a',
    duration: 10,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'Body Flirt',
    artist: 'Corduroy Mavericks & Reverand T',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/body-flirt.m4a',
    duration: 10,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'Tekneek Rekkids',
    artist: 'Corduroy Mavericks',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/tekneek-rekkids.m4a',
    duration: 20,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'Gettin Deeper',
    artist: 'Mike Geez',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/gettin-deeper.m4a',
    duration: 10,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'Pray For The Pioneers',
    artist: 'Richie Kidd ft. Sean Delaney',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/pray-for-the-pioneers.m4a',
    duration: 10,
    labelId: 'native-soul',
    genre: Genre.ChillOut
  },
  {
    name: 'Do You',
    artist: 'Brent Vassar',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/do-you.m4a',
    duration: 15,
    labelId: 'native-soul',
    genre: Genre.House
  },
  {
    name: 'Free muzique',
    artist: 'JT Donaldson',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/free-muzique.m4a',
    duration: 15,
    labelId: 'native-soul',
    genre: Genre.House
  },
  {
    name: 'Sensation',
    artist: 'Roman Nunez',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/sensation.m4a',
    duration: 15,
    labelId: 'native-soul',
    genre: Genre.House
  },
  {
    name: 'A New Direction',
    artist: 'The Candy Dealers',
    thumb: '${S3}/loops/native-soul/thumb.png',
    audio: '${S3}/loops/native-soul/a-new-direction.m4a',
    duration: 15,
    labelId: 'native-soul',
    genre: Genre.House
  },
  //   C H I L L - O U T
  {
    name: 'Chill-out One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/chillout-1.mp4',
    duration: 14,
    labelId: 'beatflyer',
    genre: Genre.ChillOut
  },
  {
    name: 'Chill-out Two',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/chillout-2.mp4',
    duration: 23,
    labelId: 'beatflyer',
    genre: Genre.ChillOut
  },
  {
    name: 'Chill-out Three',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/chillout-3.mp4',
    duration: 21,
    labelId: 'beatflyer',
    genre: Genre.ChillOut
  },
  {
    name: 'Chill-out Four',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/chillout-4.mp4',
    duration: 19,
    labelId: 'beatflyer',
    genre: Genre.ChillOut
  },
  //   P A R A S O L   C U L T U R E
  {
    name: 'Fridge Speed',
    artist: 'Tom Bulwer',
    thumb: '${S3}/loops/parasol/Fridge_Speed.jpg',
    audio: '${S3}/loops/parasol/Fridge_Speed.mp4',
    duration: 30,
    labelId: 'parasol',
    genre: Genre.House
  },
  {
    name: "It's a London Thing",
    artist: 'Tom Bulwer',
    thumb: '${S3}/loops/parasol/Its_a_London_Thing.jpg',
    audio: '${S3}/loops/parasol/Its_a_London_Thing.mp4',
    duration: 30,
    labelId: 'parasol',
    genre: Genre.House
  },
  {
    name: 'Purple Love',
    artist: 'Tom Bulwer',
    thumb: '${S3}/loops/parasol/Purple_Love.jpg',
    audio: '${S3}/loops/parasol/Purple_Love.mp4',
    duration: 30,
    labelId: 'parasol',
    genre: Genre.House
  },
  //   M A G I C   B E A T Z
  {
    name: 'Face to Face',
    version: 'Original Mix',
    artist: 'L. Caballero, J. Millan',
    thumb: '${S3}/loops/magic-beatz/Face_to_Face.jpg',
    audio: '${S3}/loops/magic-beatz/Face_to_Face_Original_Mix_loop.mp4',
    duration: 16,
    labelId: 'magic-beatz',
    genre: Genre.Techno
  },
  {
    name: 'Irie',
    version: 'Original Mix',
    artist: 'Audiotrauma',
    thumb: '${S3}/loops/magic-beatz/Up_To_Stripe.jpg',
    audio: '${S3}/loops/magic-beatz/Irie_Original_Mix_loop.mp4',
    duration: 15,
    labelId: 'magic-beatz',
    genre: Genre.Techno
  },
  {
    name: 'Up To Stripe',
    version: 'Original Mix',
    artist: 'Audiotrauma',
    thumb: '${S3}/loops/magic-beatz/Up_To_Stripe.jpg',
    audio: '${S3}/loops/magic-beatz/Up_To_Stripe_Original_Mix_loop.mp4',
    duration: 15,
    labelId: 'magic-beatz',
    genre: Genre.Techno
  },
  {
    name: 'My People',
    version: 'Victor Vergara Remix',
    artist: 'DJ Tooper',
    thumb: '${S3}/loops/magic-beatz/My_People.jpg',
    audio: '${S3}/loops/magic-beatz/My_People_Victor_Vergara_Remix_loop.mp4',
    duration: 15,
    labelId: 'magic-beatz',
    genre: Genre.Techno
  },
  {
    name: 'Androgens',
    version: 'Original Mix',
    artist: 'Victor Vergara',
    thumb: '${S3}/loops/magic-beatz/Androgens.jpg',
    audio: '${S3}/loops/magic-beatz/Androgens_Original_Mix_loop.mp4',
    duration: 16,
    labelId: 'magic-beatz',
    genre: Genre.Techno
  },
  //   F I N E   D A Y
  {
    name: 'Mustang',
    version: 'Riva Starr Remix',
    artist: 'Hermanos Inglesos',
    thumb: '${S3}/loops/fine-day/Mustang_Riva_Starr_Remix.jpg',
    audio: '${S3}/loops/fine-day/Mustang_Riva_Starr_Remix_loop.mp4',
    duration: 8,
    labelId: 'fine-day',
    genre: Genre.EDM
  },
  {
    name: 'Home 0207',
    version: 'Hermanos Inglesos Remix Part 2',
    artist: 'Plastic Operator',
    thumb: '${S3}/loops/fine-day/Home_0207_Hermanos_Inglesos_Remix_Part_2.jpg',
    audio:
      '${S3}/loops/fine-day/Home_0207_Hermanos_Inglesos_Remix_Part_2_loop.mp4',
    duration: 15,
    labelId: 'fine-day',
    genre: Genre.Techno
  },
  {
    name: 'Singing All The Time',
    version: 'The Sanfernando Sound',
    artist: 'Plastic Operator',
    thumb:
      '${S3}/loops/fine-day/Singing_All_The_Time_The_Sanfernando_Sound_Remix.jpg',
    audio:
      '${S3}/loops/fine-day/Singing_All_The_Time_The_Sanfernando_Sound_Remix_loop.mp4',
    duration: 15,
    labelId: 'fine-day',
    genre: Genre.EDM
  },
  {
    name: 'Parasol',
    version: 'Easy D Remix',
    artist: 'Plastic Operator',
    thumb: '${S3}/loops/fine-day/Parasols_Easy_D_Remix.jpg',
    audio: '${S3}/loops/fine-day/Parasols_Easy_D_Remix_loop.mp4',
    duration: 14,
    labelId: 'fine-day',
    genre: Genre.House
  },
  {
    name: 'London Via Milan',
    version: 'Ronnie Rose Remix',
    artist: 'Raphael, Lucchi', // 'Alexis Raphael, Paolo Lucchi',
    thumb: '${S3}/loops/fine-day/London_Via_Milan_Ronnie_Rose_Remix.jpg',
    audio: '${S3}/loops/fine-day/London_Via_Milan_Ronnie_Rose_Remix_loop.mp4',
    duration: 15,
    labelId: 'fine-day',
    genre: Genre.Techno
  },
  {
    name: 'Barcelona',
    version: 'Original Mix',
    artist: 'Ronnie Rose',
    thumb: '${S3}/loops/fine-day/Barcelona_Original_Mix.jpg',
    audio: '${S3}/loops/fine-day/Barcelona_Original_Mix_loop.mp4',
    duration: 15,
    labelId: 'fine-day',
    genre: Genre.House
  },

  //   K R K R
  {
    name: 'Motorway to Park',
    version: 'Korinami Remix',
    artist: 'Claudio Iacono',
    thumb: '${S3}/loops/krkr/ippodo-blend.jpg',
    audio: '${S3}/loops/krkr/Motorway_to_Park_Korinami_Remix_loop.mp4',
    duration: 8,
    labelId: 'krkr',
    genre: Genre.Techno
  },
  {
    name: 'Motorway to Park',
    version: 'Paolo Lucchi Remix',
    artist: 'Claudio Iacono',
    thumb: '${S3}/loops/krkr/ippodo-blend.jpg',
    audio: '${S3}/loops/krkr/Motorway_to_Park_Paolo_Lucchi_Remix_loop.mp4',
    duration: 16,
    labelId: 'krkr',
    genre: Genre.Techno
  },
  {
    name: 'Motorway to Park',
    version: 'Esse Remix',
    artist: 'Claudio Iacono',
    thumb: '${S3}/loops/krkr/ippodo-blend.jpg',
    audio: '${S3}/loops/krkr/Motorway_to_Park_Esse_Remix_loop.mp4',
    duration: 15,
    labelId: 'krkr',
    genre: Genre.Techno
  },
  {
    name: 'Lower',
    version: 'Original Mix',
    artist: 'Korinami',
    thumb: '${S3}/loops/krkr/monocerotis.jpg',
    audio: '${S3}/loops/krkr/Lower_Original_Mix_loop.mp4',
    duration: 16,
    labelId: 'krkr',
    genre: Genre.Techno
  },
  {
    name: 'Buckfast',
    version: 'Original Mix',
    artist: 'Korinami',
    thumb: '${S3}/loops/krkr/monocerotis.jpg',
    audio: '${S3}/loops/krkr/Buckfast_Original_Mix_loop.mp4',
    duration: 15,
    labelId: 'krkr',
    genre: Genre.Techno
  },
  {
    name: 'Boontom',
    version: 'Original Mix',
    artist: 'Korinami',
    thumb: '${S3}/loops/krkr/monocerotis.jpg',
    audio: '${S3}/loops/krkr/Boontom_Original_Mix_loop.mp4',
    duration: 32,
    labelId: 'krkr',
    genre: Genre.Techno
  },
  {
    name: 'Apples',
    version: 'Original Mix',
    artist: 'Korinami',
    thumb: '${S3}/loops/krkr/blue-klein.jpg',
    audio: '${S3}/loops/krkr/Apples_Original_Mix_loop.mp4',
    duration: 15,
    labelId: 'krkr',
    genre: Genre.Techno
  },
  {
    name: 'Beam',
    version: 'Original Mix',
    artist: 'Korinami',
    thumb: '${S3}/loops/krkr/spoke.jpg',
    audio: '${S3}/loops/krkr/Beam_Original_Mix_loop.mp4',
    duration: 15,
    labelId: 'krkr',
    genre: Genre.Techno
  },
  {
    name: 'Radius',
    version: 'Original Mix',
    artist: 'Korinami',
    thumb: '${S3}/loops/krkr/spoke.jpg',
    audio: '${S3}/loops/krkr/Radius_Original_Mix_loop.mp4',
    duration: 15,
    labelId: 'krkr',
    genre: Genre.Techno
  },
  {
    name: 'Circles',
    version: 'Original Mix',
    artist: 'Paolo Lucchi',
    thumb: '${S3}/loops/krkr/flow.jpg',
    audio: '${S3}/loops/krkr/Circles_Original_Mix_loop.mp4',
    duration: 16,
    labelId: 'krkr',
    genre: Genre.Techno
  },
  {
    name: 'Disturbing Behavior',
    version: 'Davide Vario Remix',
    artist: 'Everdom',
    thumb: '${S3}/loops/krkr/paranoia.jpg',
    audio: '${S3}/loops/krkr/Disturbing_Behavior_Davide_Vario_Remix_loop.mp4',
    duration: 15,
    labelId: 'krkr',
    genre: Genre.Techno
  },
  {
    name: 'The Party',
    version: 'Neil Catlin Remix',
    artist: 'Enrico Fiorella',
    thumb: '${S3}/loops/krkr/the-party.jpg',
    audio: '${S3}/loops/krkr/The_Party_Neil_Catlin_Remix_loop.mp4',
    duration: 15,
    labelId: 'krkr',
    genre: Genre.Techno
  },
  {
    name: 'The Party',
    version: 'Original Mix',
    artist: 'Enrico Fiorella',
    thumb: '${S3}/loops/krkr/the-party.jpg',
    audio: '${S3}/loops/krkr/The_Party_Original_Mix_loop.mp4',
    duration: 16,
    labelId: 'krkr',
    genre: Genre.Techno
  },
  {
    name: 'Psychelectrick',
    version: 'Original Mix',
    artist: 'Paolo Lucchi',
    thumb: '${S3}/loops/krkr/Psychelectrick_Original_Mix.jpg',
    audio: '${S3}/loops/krkr/Psychelectrick_Original_Mix_loop.mp4',
    duration: 15,
    labelId: 'krkr',
    genre: Genre.Techno
  },
  {
    name: 'Further',
    version: 'Original Mix',
    artist: 'Paolo Lucchi',
    thumb: '${S3}/loops/krkr/Psychelectrick_Original_Mix.jpg',
    audio: '${S3}/loops/krkr/Further_Original_Mix_loop.mp4',
    duration: 16,
    labelId: 'krkr',
    genre: Genre.Techno
  },
  {
    name: 'Consumed',
    version: 'Nicola Nolli Remix',
    artist: 'Everdom',
    thumb: '${S3}/loops/krkr/paranoia.jpg',
    audio: '${S3}/loops/krkr/Consumed_Nicola_Nolli_Remix_loop.mp4',
    duration: 16,
    labelId: 'krkr',
    genre: Genre.Techno
  },

  //   E D M
  {
    name: 'EDM One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/edm-1.mp4',
    duration: 8,
    labelId: 'beatflyer',
    genre: Genre.EDM
  },
  {
    name: 'EDM Two',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/edm-2.mp4',
    duration: 15,
    labelId: 'beatflyer',
    genre: Genre.EDM
  },
  {
    name: 'EDM Three',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/edm-3.mp4',
    duration: 8,
    labelId: 'beatflyer',
    genre: Genre.EDM
  },
  {
    name: 'EDM Four',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/edm-4.mp4',
    duration: 15,
    labelId: 'beatflyer',
    genre: Genre.EDM
  },
  {
    name: 'EDM Five',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/edm-5.mp4',
    duration: 15,
    labelId: 'beatflyer',
    genre: Genre.EDM
  },
  {
    name: 'EDM Six',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/edm-6.mp4',
    duration: 15,
    labelId: 'beatflyer',
    genre: Genre.EDM
  },
  {
    name: 'EDM Seven',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/edm-7.mp4',
    duration: 15,
    labelId: 'beatflyer',
    genre: Genre.EDM
  },
  {
    name: 'EDM Eight',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/edm-8.mp4',
    duration: 15,
    labelId: 'beatflyer',
    genre: Genre.EDM
  },
  {
    name: 'EDM Nine',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/edm-9.mp4',
    duration: 15,
    labelId: 'beatflyer',
    genre: Genre.EDM
  },

  {
    name: 'Dutch One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/dutch-1.mp4',
    duration: 15,
    labelId: 'beatflyer',
    genre: Genre.EDM
  },
  {
    name: 'Dutch Two',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/dutch-2.mp4',
    duration: 7,
    labelId: 'beatflyer',
    genre: Genre.EDM
  },

  //   T E C H N O
  {
    name: 'Techno One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/techno-1.mp4',
    duration: 15,
    labelId: 'beatflyer',
    genre: Genre.Techno
  },
  {
    name: 'Techno Two',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/techno-2.mp4',
    duration: 15,
    labelId: 'beatflyer',
    genre: Genre.Techno
  },

  //   M I N I M A L
  {
    name: 'Minimal One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/minimal-1.mp4',
    duration: 16,
    labelId: 'beatflyer',
    genre: Genre.Techno
  },
  {
    name: 'Minimal Two',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/minimal-2.mp4',
    duration: 8,
    labelId: 'beatflyer',
    genre: Genre.Techno
  },
  {
    name: 'Minimal Three',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/minimal-3.mp4',
    duration: 8,
    labelId: 'beatflyer',
    genre: Genre.Techno
  },
  {
    name: 'Minimal Four',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/minimal-4.mp4',
    duration: 8,
    labelId: 'beatflyer',
    genre: Genre.Techno
  },
  {
    name: 'Minimal Five',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/minimal-5.mp4',
    duration: 16,
    labelId: 'beatflyer',
    genre: Genre.Techno
  },

  //   T E C H   H O U S E
  {
    name: 'Tech House One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/tech-house-1.mp4',
    duration: 15,
    labelId: 'beatflyer',
    genre: Genre.Techno
  },
  {
    name: 'Tech House Two',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/tech-house-2.mp4',
    duration: 15,
    labelId: 'beatflyer',
    genre: Genre.Techno
  },
  {
    name: 'Tech House Three',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/tech-house-3.mp4',
    duration: 8,
    labelId: 'beatflyer',
    genre: Genre.Techno
  },
  {
    name: 'Tech House Four',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/tech-house-4.mp4',
    duration: 15,
    labelId: 'beatflyer',
    genre: Genre.Techno
  },

  {
    name: 'Progressive One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/progressive-house-1.mp4',
    duration: 8,
    labelId: 'beatflyer',
    genre: Genre.House
  },
  {
    name: 'Progressive Two',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/progressive-house-2.mp4',
    duration: 15,
    labelId: 'beatflyer',
    genre: Genre.House
  },
  {
    name: 'Progressive Three',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/progressive-house-3.mp4',
    duration: 15,
    labelId: 'beatflyer',
    genre: Genre.House
  },
  {
    name: 'Progressive Four',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/progressive-house-4.mp4',
    duration: 16,
    labelId: 'beatflyer',
    genre: Genre.House
  },

  //   H O U S E
  {
    name: 'House One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/house-1.mp4',
    duration: 8,
    labelId: 'beatflyer',
    genre: Genre.House
  },
  {
    name: 'House Two',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/house-2.mp4',
    duration: 8,
    labelId: 'beatflyer',
    genre: Genre.House
  },
  {
    name: 'House Three',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/house-3.mp4',
    duration: 8,
    labelId: 'beatflyer',
    genre: Genre.House
  },
  {
    name: 'House Four',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/house-4.mp4',
    duration: 7,
    labelId: 'beatflyer',
    genre: Genre.House
  },
  {
    name: 'Deep House One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/deep-house-1.mp4',
    duration: 15,
    labelId: 'beatflyer',
    genre: Genre.House
  },

  //   D I S C O
  {
    name: 'Disco One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/disco-1.mp4',
    duration: 8,
    labelId: 'beatflyer',
    genre: Genre.Disco
  },
  {
    name: 'Disco Two',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/disco-2.mp4',
    duration: 17,
    labelId: 'beatflyer',
    genre: Genre.Disco
  },
  {
    name: 'Disco Three',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/disco-3.mp4',
    duration: 16,
    labelId: 'beatflyer',
    genre: Genre.Disco
  },
  {
    name: 'Disco Four',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/disco-4.mp4',
    duration: 16,
    labelId: 'beatflyer',
    genre: Genre.Disco
  },
  {
    name: 'Disco Five',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/disco-5.mp4',
    duration: 16,
    labelId: 'beatflyer',
    genre: Genre.Disco
  },

  //   D U B S T E P
  {
    name: 'Dubstep One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/dubstep-1.mp4',
    duration: 17,
    labelId: 'beatflyer',
    genre: Genre.Dubstep
  },
  {
    name: 'Jamaica',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/Jamaica-loop.mp4',
    duration: 13,
    labelId: 'beatflyer',
    genre: Genre.Dubstep
  },
  {
    name: 'Pop That',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/Pop-That-loop.mp4',
    duration: 13,
    labelId: 'beatflyer',
    genre: Genre.Dubstep
  },
  {
    name: 'Psycho',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/Psycho-loop.mp4',
    duration: 13,
    labelId: 'beatflyer',
    genre: Genre.Dubstep
  },

  //   D R U M   &   B A S S
  {
    name: 'Drum & Bass One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/drum-bass-1.mp4',
    duration: 11,
    labelId: 'beatflyer',
    genre: Genre.DrumAndBass
  },
  {
    name: 'Drum & Bass Two',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/drum-bass-2.mp4',
    duration: 11,
    labelId: 'beatflyer',
    genre: Genre.DrumAndBass
  },
  {
    name: 'Drum & Bass Three',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/drum-bass-3.mp4',
    duration: 22,
    labelId: 'beatflyer',
    genre: Genre.DrumAndBass
  },
  {
    name: 'Drum & Bass Four',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/drum-bass-4.mp4',
    duration: 22,
    labelId: 'beatflyer',
    genre: Genre.DrumAndBass
  },
  {
    name: 'Drum & Bass Five',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/drum-bass-5.mp4',
    duration: 22,
    labelId: 'beatflyer',
    genre: Genre.DrumAndBass
  },

  //   Hip Hop
  {
    name: 'Hip Hop One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/hip-hop-1.mp4',
    duration: 10,
    labelId: 'beatflyer',
    genre: Genre.HipHop
  },
  {
    name: 'Hip Hop Two',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/hip-hop-2.mp4',
    duration: 10,
    labelId: 'beatflyer',
    genre: Genre.HipHop
  },
  {
    name: 'Hip Hop Three',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/hip-hop-3.mp4',
    duration: 11,
    labelId: 'beatflyer',
    genre: Genre.HipHop
  },
  {
    name: 'Hip Hop Four',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/hip-hop-4.mp4',
    duration: 20,
    labelId: 'beatflyer',
    genre: Genre.HipHop
  },

  //   T R A P
  {
    name: 'Trap One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/trap-1.mp4',
    duration: 11,
    labelId: 'beatflyer',
    genre: Genre.Trap
  },
  {
    name: 'Trap Two',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/trap-2.mp4',
    duration: 11,
    labelId: 'beatflyer',
    genre: Genre.Trap
  },
  {
    name: 'Trap Three',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/trap-3.mp4',
    duration: 11,
    labelId: 'beatflyer',
    genre: Genre.Trap
  },
  {
    name: 'Trap Four',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/trap-4.mp4',
    duration: 11,
    labelId: 'beatflyer',
    genre: Genre.Trap
  },

  //   F U N K
  {
    name: 'Funk One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/funk-1.mp4',
    duration: 17,
    labelId: 'beatflyer',
    genre: Genre.Funk
  },
  {
    name: 'Funk Two',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/funk-2.mp4',
    duration: 16,
    labelId: 'beatflyer',
    genre: Genre.Funk
  },
  {
    name: 'Funk Three',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/funk-3.mp4',
    duration: 18,
    labelId: 'beatflyer',
    genre: Genre.Funk
  },
  {
    name: 'Funk Four',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/funk-4.mp4',
    duration: 16,
    labelId: 'beatflyer',
    genre: Genre.Funk
  },

  //   L A T I N O
  {
    name: 'Latino One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/latino-1.mp4',
    duration: 22,
    labelId: 'beatflyer',
    genre: Genre.Latino
  },
  {
    name: 'Latino Two',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/latino-2.mp4',
    duration: 21,
    labelId: 'beatflyer',
    genre: Genre.Latino
  },
  {
    name: 'Latino Three',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/latino-3.mp4',
    duration: 19,
    labelId: 'beatflyer',
    genre: Genre.Latino
  },

  //   R E G G A E
  {
    name: 'Reggae One',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/reggae-1.mp4',
    duration: 19,
    labelId: 'beatflyer',
    genre: Genre.Reggae
  },
  {
    name: 'Reggae Two',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/reggae-2.mp4',
    duration: 20,
    labelId: 'beatflyer',
    genre: Genre.Reggae
  },
  {
    name: 'Reggae Three',
    thumb: '${S3}/loops/beatflyer.png',
    audio: '${S3}/loops/reggae-3.mp4',
    duration: 19,
    labelId: 'beatflyer',
    genre: Genre.Reggae
  }
];

export default JSON.parse(
  JSON.stringify(loops).split('${S3}/').join(getBaseURL())
) as Loop[];



// WEBPACK FOOTER //
// ./src/audio-editing/loops.ts